export default __webpack_public_path__ + "assets/icon-table-refresh.ffd03c45.webp";